<template>
  <!-- @lookmore="more" -->
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <p class="center pad10" @click="showPopup = !showPopup">
    {{ years }}
  </p>
  <div class="mycalendar">
    <!-- 
      poppable	是否以弹层的形式展示日历
      show-title是否展示日历标题
      row-height 日期行高
      show-confirm 是否展示确认按钮
      @select 点击日期时触发
      minDate-maxDate  日期范围
      show-subtitle 是否展示日历副标题
      default-date 默认选中日期
      formatter 日期格式化函数
      safe-area-inset-bottom 是否开启底部安全区适配
     -->
    <van-calendar v-if="list != null" class="myCalendar" :poppable="false" :show-title="false" row-height="60px" :show-confirm="false"
      @select="select" :maxDate="maxDate" :show-subtitle="false" :minDate="minDate" :default-date="new Date()" :formatter="formatter"
      :safe-area-inset-bottom="false" />
  </div>

  <div class="pad14" v-if="offlineTime">
    <van-button round block type="primary" v-if="offlineTime.is_apply == 1" class="opacity4">当前日期已选</van-button>
    <van-button round block type="primary" v-else-if="offlineTime.num == 0" class="opacity4">选择日期</van-button>
    <van-button round block type="primary" v-else @click="onConfirm">确认提交</van-button>
  </div>
<!-- 通过底部弹窗茄皇时间 -->
  <van-popup v-model:show="showPopup" position="bottom">
  <!--
    minDate:时间范围最小时间 
    columns-type:展示项、控制选项类型
    -->
 
    <van-date-picker title="选择年月" :minDate="new Date()" :columns-type="['year', 'month']" @confirm="datePicker" @cancel="datePicker()" />
  </van-popup>
</template>

<script>
import { formatDate } from "@/utils/util.js";
import { showConfirmDialog } from 'vant';
export default {
  name: "Home",
  data () {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    return {
      showPopup: false,
      maxDate: new Date(year, month + 1, 0),//日历的最大时间  month+1:下个月   0:表示上个月的最后一天
      minDate: new Date(new Date().setDate(1)),//setDate()设置日期，当前月的第一天
      selectDate: new Date(),//选中日期
      offlineTime: null,//object  选中项   apply_time:选中时间  is_apply:是否选中  num:余量
      list: null,
      lists: null,
    };
  },
  methods: {
    formatDate,
    // 点击选中项
    select (v) {
      const date = new Date(v)
      const month = ((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '月'
      const day = (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) + '日'
      // 跳出弹窗
      showConfirmDialog({
        title: '日期确认',
        message:
          '您预约的日期为' + month + day + ',' + '\n是否确认该天赴约?',
      })
        .then(() => {
          // on confirm
          this.selectDate = v;
          this.offlineTime = this.lists.find((item) => { return item.apply_time == formatDate(v) });
        })
        .catch(() => {
          // on cancel
        });
      // console.log(formatDate(v));
    },
    // 确认提交
    onConfirm () {
      this.ajax({
        method: "post",
        url: "forum/choosetime",
        data: {
          id: this.$route.query.id,//会议id
          apply_time: this.offlineTime.apply_time,//选中时间
        },
        myData: { showMsg: true },
      }).finally(() => {
        this.$router.push({ path: "/forum", query: { active: 1 } });
      });
    },
    // 格式化样式
    formatter (day) {
      // 日期逐个遍历  
      let date = this.list.find(
        (item) => {
          return item.apply_time == formatDate(day.date)
        }
      );
      // 所选天数余量为空时 禁用并灰度
      if (
        date &&
        ((date.num != undefined && date.num == 0) ||
          new Date(date.apply_time) < new Date(formatDate(new Date())))
      ) {
        day.className = "filterGray";
        day.type = "disabled";
      }
      // 设置剩余量
      return { ...day, bottomInfo: date ? "余" + date.num : "余0" };
    },
    next () {
      history.forward();
    },
    // 切换时间
    datePicker (date) {
      this.showPopup = false;
      if (date) {
        let year = date.selectedValues;
        this.maxDate = new Date(
          year[0],//选中年
          year[1] - 1,
          new Date(year[0], year[1], 0).getDate()//设置月的最后一天  月份为year[1]-1
        );
        this.selectDate = this.maxDate;//默认选中最后一天
        this.minDate = new Date(year[0], year[1] - 1, 1);//设置月的第一天  月份为year[1]-1
        this.currentDate = new Date(this.minDate);
        this.getTime(year.join("-"));//例：2024-01
      }
    },
    // 请求时间
    getTime (years) {
      if (!years) {
        return;
      }
      this.years = years;
      this.ajax
        .post("forum/offlineforumtime", { id: this.$route.query.id, years })
        .then(({ data }) => {
          this.list = data || [];
          this.lists = data || [];
          this.offlineTime = this.list.find(
            (item) => item.apply_time == formatDate(years)
          );
        });
    },
  },
  computed: {},
  created () {
    this.currentDate = new Date();
    this.getTime(
      this.currentDate.getFullYear() +
      "-" +
      ((d) => (d > 9 ? d : "0" + d))(this.currentDate.getMonth() + 1)
    );
  },
};
</script>

<style>

</style>
